import { api } from ".";

export interface AppRegistration {
  Id: number;
  ClientName: string;
  ClientDescription: string;
  AppRegistrationName: string;
  ObjectId: string;
  SecretVaultUrl: string;
  SecretExpirationDate?: Date;
  ContactEmail: string;
  IsActive: boolean;
  RegistrationSuccess: boolean;
  CreatedByUserId: number;
  CreatedByUser: string;
  CreatedDateUtc: Date;
  CustomerId: number;
  ApplicationIds: number[]; 
}


export interface AppRegistrationModel {
  ClientName: string;
  ClientDescription: string;
  ContactEmail: string;
  CustomerId: number;
  ApplicationIds: number[];
}


const appRegistrationsUrlV1 = "/v1/AppRegistrations";
const customerAppRegistrationsUrlV1 = "/v1/CustomerAppRegistrations";

export const getAppRegistrationsByCustomerId = async (customerId: number) => {
  const response = await api.get<AppRegistration[]>(`${customerAppRegistrationsUrlV1}/${customerId}/appRegistrations`);
  return response?.data;
};


export const addAppRegistration = async (appRegModel: AppRegistrationModel) => {
  const response = await api.post(appRegistrationsUrlV1, appRegModel);
  return response?.data;
}

export const updateAppRegistration = async (appRegModelId: number, appRegModel: AppRegistrationModel) => {
  const response = await api.put(`${appRegistrationsUrlV1}/${appRegModelId}`, appRegModel);
  return response?.status === 200;
}

export const generateNewAppRegistrationSecret = async (appRegModelId: number) => {
  const response = await api.patch(`${appRegistrationsUrlV1}/${appRegModelId}/secret`);
  return response?.data;
}

export const getAppRegistrationSecret = async (appRegModelId: number) => {
  const response = await api.get<string>(`${appRegistrationsUrlV1}/${appRegModelId}/secret`);
  return response?.data;
}

export const deleteAppRegistration = async (appRegId: number) => {
  const response = await api.delete(`${appRegistrationsUrlV1}/${appRegId}`);
  return response?.data;
}
